import React from 'react';
import glamorous from 'glamorous';
import { onlyUpdateForKeys, compose, lifecycle } from 'recompose';
import { Tree } from '@blueprintjs/core';

const StyledTree = glamorous(Tree)({
  paddingTop: 5,
  marginTop: 5,
  marginBottom: 10,
  maxHeight: 300,
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: 7,
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: 'rgba(0,0,0,.5)',
  },
}, ({ isTree, isRtl }) => ({
  '& .pt-tree-node-content': {
    height: 'auto',
  },
  '& .pt-tree-node-label': {
    overflow: 'auto',
    whiteSpace: 'unset',
    wordWrap: 'break-word',
    marginTop: 2,
    marginBottom: 2,
  },
  '& .pt-tree-node-content-1': {
    paddingLeft: 5,
  },
  '& .pt-tree-node-content-2': {
    paddingLeft: 10,
  },
  '& .pt-tree-node-content-3': {
    paddingLeft: 15,
  },
  '& .pt-tree-node-content-4': {
    paddingLeft: 20,
  },
  '& .pt-tree-node-content-5': {
    paddingLeft: 25,
  },
  '& .pt-tree-root': {
    paddingRight: isRtl ? 0 : null,
  },
  '& .pt-tree-node-content-0': {
    paddingLeft: isTree ? 0 : 10,
  },
  '& .pt-tree-node-caret-none': {
    minWidth: isTree ? 30 : 0,
  },
  '& .pt-tree-node-caret::before': {
    content: isRtl ? `"\\E694"` : `"\\E695"`,
  },
  '& .pt-tree-node-caret.pt-tree-node-caret-open::before': {
    transform: isRtl ? 'rotate(-90deg)' : 'rotate(90deg)',
  },
}));

export const VXFilterTree = (props) => (
  <StyledTree
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/views/visions/vx-filter-tree.js